import { useState, useEffect } from "react";

const STORAGE_KEY = "gtg_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(STORAGE_KEY);
    if (!consent) {
      // Delay appearance so it doesn't block first impression
      const timer = setTimeout(() => setVisible(true), 2500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(STORAGE_KEY, "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-[380px] w-[calc(100%-2rem)]">
      <div className="bg-white/95 backdrop-blur-md border border-slate-200/80 rounded-2xl p-5">
        <p className="text-[13px] text-slate-600 leading-relaxed mb-4">
          我們使用 Cookie 來提升瀏覽體驗與分析流量。繼續使用即表示同意我們的
          <a href="/privacy" className="text-primary hover:underline mx-0.5">
            隱私政策
          </a>
          。
        </p>
        <div className="flex items-center gap-2">
          <button
            onClick={handleDecline}
            className="flex-1 px-3 py-2 text-[13px] font-medium text-slate-500 hover:text-slate-700 transition-colors cursor-pointer whitespace-nowrap rounded-lg hover:bg-slate-50"
          >
            拒絕
          </button>
          <button
            onClick={handleAccept}
            className="flex-1 px-3 py-2 text-[13px] font-medium bg-primary text-white rounded-full hover:bg-primary-dark transition-colors cursor-pointer whitespace-nowrap"
          >
            我同意
          </button>
        </div>
      </div>
    </div>
  );
}